/* global moment */
import { connect } from 'react-redux';
import View from './View';
import * as selector from '../../TransactionsSelector';
import { currentClientIdSelector } from '../../../CommonSelectors/CommonAreaSelector';
import {
  closeModal,
  updateDraftTransaction,
  saveTransaction,
  clearErrors,
  openDeleteModal,
  setErrors,
} from '../../TransactionsActions';

const mapStateToProps = state => ({
  accountsList: selector.accountsSelector(state),
  categoriesList: selector.expenseCategoryOptionsSelector(state),
  clientId: currentClientIdSelector(state),
  daysOptions: selector.getDaysOptions(),
  draftTransaction: selector.draftTransaction(state),
  errors: selector.errors(state),
  isOpen: selector.isAddUpdateModalOpen(state),
  monthsOptions: selector.getMonthsOptions(),
  yearOptions: selector.getYearOptions(),
  isEdit: selector.isEdit(state),
  formErrors: selector.formErrors(state),
  expenseCategoryFilter: selector.expenseCategoryFilter(state),
  currentAccount: selector.currentAccountSelector(state),
  currentPeriodId: selector.currentPeriodIdSelector(state),
  currentQuery: selector.currentQuerySelector(state),
  pagination: selector.paginationSelector(state),
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal()),
  openDeleteModal: () => dispatch(openDeleteModal()),
  updateDraftTransaction: draftData => dispatch(updateDraftTransaction(draftData)),
  saveTransaction: (
    formErrors,
    draftTransaction,
    clientId,
    accountId,
    periodId,
    query,
    category,
    page,
  ) => {
    if (formErrors.length > 0) {
      dispatch(setErrors(formErrors));
    } else {
      const {
        month,
        year,
        day,
        description: Description,
        category: Category,
        account,
        amount: Balance,
        ...transaction
      } = draftTransaction;

      const UTCDate = moment.utc(`${month}-${day}-${year}`, 'MM-DD-YYYY');

      if (!UTCDate.isValid()) {
        dispatch(setErrors(['Invalid date']));
      } else {
        const dateISOString = UTCDate.toISOString();

        const data = {
          Date: dateISOString,
          AccountName: account.label || account.accountName,
          AccountId: account.value || account.accountId,
          Description,
          Category,
          Balance,
          ...transaction,
        };

        dispatch(saveTransaction(clientId, data, accountId, periodId, query, category, page));
      }
    }
  },
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
